import type { Locale, RouteKind, SeoContent } from "./types";

export const seoByLocale: Record<Locale, Record<RouteKind, SeoContent>> = {
  en: {
    landing: {
      title: "Moodshot - Snap a photo, hear the mood.",
      description:
        "Your surroundings often reflect how you feel. Snap what is in front of you and let Moodshot turn the light, scene, and hour into a spinning record with a matching Apple Music playlist. Recognition runs entirely on your device."
    },
    privacy: {
      title: "Privacy Policy - Moodshot",
      description:
        "Moodshot collects nothing. Photos are analysed on your device and never uploaded to our servers; saved moments sync to your own private iCloud, which we cannot read. No account, no analytics, no third-party SDKs."
    },
    support: {
      title: "Support - Moodshot",
      description:
        "Help with Moodshot: why some songs play for only 30 seconds, what to do when no playlist is found, how to switch to a different mood, and where saved moments are kept."
    },
    terms: {
      title: "Terms of Use - Moodshot",
      description:
        "The terms that apply when you use Moodshot, an iPhone and iPad app that turns a photo into an Apple Music playlist. Free to download, with one optional in-app purchase."
    }
  },
  zh: {
    landing: {
      title: "Moodshot - 拍下所见，听懂此刻的心情",
      description:
        "眼前的环境，往往映照着当下的心情。掏出手机拍下眼前的一角，让周遭的光影为你转动一张对味的黑胶唱片。识别完全在本地运行，不必联网。"
    },
    privacy: {
      title: "隐私政策 - Moodshot",
      description:
        "Moodshot 不收集任何信息。照片在设备上分析，从不上传到我们的服务器；收藏会同步进你自己的 iCloud 私有空间，我们读不到。没有账号、没有统计、不含第三方 SDK。"
    },
    support: {
      title: "用户支持 - Moodshot",
      description: "Moodshot 使用帮助：为什么有时候每首歌只播 30 秒、提示找不到歌单怎么办、怎么换一个氛围、收藏存在哪里。"
    },
    terms: {
      title: "用户协议 - Moodshot",
      description: "使用 Moodshot（一款把照片变成 Apple Music 歌单的 iPhone 与 iPad App，免费下载，含一项可选内购）时适用的条款。"
    }
  },
  "zh-Hant": {
    landing: {
      title: "Moodshot - 拍一張照片，讀懂這一刻的心情",
      description:
        "眼前的環境，往往映照著當下的心情。拿起手機拍下眼前一角，讓周遭的光影為你轉出一張對味的黑膠唱片。辨識完全在裝置端運行，不必連網。"
    },
    privacy: {
      title: "隱私權政策 - Moodshot",
      description:
        "Moodshot 不收集任何資訊。照片在裝置上分析，從不上傳到我們的伺服器；收藏會同步進你自己的 iCloud 私有空間，我們讀不到。沒有帳號、沒有統計、不含第三方 SDK。"
    },
    support: {
      title: "支援 - Moodshot",
      description: "Moodshot 使用幫助：為什麼有時候每首歌只播 30 秒、提示找不到播放列表怎麼辦、怎麼換一個氛圍、收藏存在哪裡。"
    },
    terms: {
      title: "使用條款 - Moodshot",
      description: "使用 Moodshot（一款把照片變成 Apple Music 播放列表的 iPhone 與 iPad App，免費下載，含一項可選 App 內購買）時適用的條款。"
    }
  }
};

/**
 * 模板 index.html 里那块 MobileApplication JSON-LD 的描述。
 * 预渲染时按语言替换，中文页不要停留在英文描述。
 */
export const appJsonLdDescriptionByLocale: Record<Locale, string> = {
  en: "Your surroundings often reflect how you feel. Snap what is in front of you and let Moodshot turn the light, scene, and hour into a spinning vinyl record with a matching Apple Music playlist. Recognition runs entirely on your device.",
  zh: "眼前的环境往往映照着当下的心情。随手拍下眼前的一角，Moodshot 在本地读懂光线、场景与时段，为你转动一张对味的黑胶唱片。识别依据清晰可见，识别全程不必联网。",
  "zh-Hant": "眼前的環境往往映照著當下的心情。隨手拍下眼前一角，Moodshot 在裝置端讀懂光線、場景與時段，為你轉出一張對味的黑膠唱片。辨識依據清晰可見，辨識全程不必連網。"
};
